// prettier-ignore
export default {
  __proto__: null,
  // Example:
  // "transform-class-static-block": "proposal-class-static-block",
};
